(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fo-community"] && !Shopify.designMode) return;
  try {
    
  function setupFoCommunity(root) {
    root.querySelectorAll('[data-fo-community]').forEach(section => {
      if (section.dataset.bound) return;
      section.dataset.bound = 'true';
      const track = section.querySelector('.fo-community__track');
      const arrows = section.querySelectorAll('[data-fo-direction]');
      const update = () => arrows.forEach(button => { button.disabled = Number(button.dataset.foDirection) < 0 ? track.scrollLeft <= 1 : track.scrollLeft + track.clientWidth >= track.scrollWidth - 1; });
      arrows.forEach(button => button.addEventListener('click', () => track.scrollBy({left: Number(button.dataset.foDirection) * (track.clientWidth + 20), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'})));
      track.addEventListener('scroll', update, {passive: true});
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
      section.querySelectorAll('[data-fo-open]').forEach(button => {
        const dialog = section.querySelector('#' + CSS.escape(button.dataset.foOpen));
        button.addEventListener('click', () => {
          const player = dialog.querySelector('[data-fo-player]');
          if (!player.firstElementChild) player.append(dialog.querySelector('template').content.cloneNode(true));
          dialog.showModal();
          document.documentElement.classList.add('fo-video-open');
          dialog.querySelector('video')?.play().catch(() => {});
        });
        dialog.querySelector('[data-fo-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
        dialog.addEventListener('close', () => {
          dialog.querySelector('video')?.pause();
          if (dialog.querySelector('iframe')) dialog.querySelector('[data-fo-player]').replaceChildren();
          document.documentElement.classList.remove('fo-video-open');
          button.focus({preventScroll: true});
        });
      });
    });
  }
  setupFoCommunity(document);
  document.addEventListener('shopify:section:load', event => setupFoCommunity(event.target));
  document.addEventListener('shopify:section:unload', () => document.documentElement.classList.remove('fo-video-open'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fo-depot-preview"] && !Shopify.designMode) return;
  try {
    
const foFrame = document.getElementById('fo-depot-frame');
window.addEventListener('message',event=>{if(!foFrame||event.source!==foFrame.contentWindow||event.data?.type!=='fo-return-home')return;const home=new URL(foFrame.dataset.homeUrl,window.location.origin);const preview=new URLSearchParams(window.location.search).get('preview_theme_id');if(preview)home.searchParams.set('preview_theme_id',preview);window.location.assign(home.href);});
if(foFrame){const title=new URLSearchParams(window.location.search).get('monture');if(title){const deliver=()=>foFrame.contentWindow.postMessage({type:'fo-frame',title:title.slice(0,200)},'*');foFrame.addEventListener('load',deliver);deliver();}}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fo-hero"] && !Shopify.designMode) return;
  try {
    
function setupFoHeroes(root){
 root.querySelectorAll('.fo-hero video').forEach(video=>{
  if(video.dataset.foAutoplay)return;
  video.dataset.foAutoplay='true';video.muted=true;video.defaultMuted=true;video.playsInline=true;
  const play=()=>{const attempt=video.play();if(attempt)attempt.catch(()=>{});};
  video.addEventListener('canplay',play,{once:true});play();
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)play()});
  document.addEventListener('touchstart',play,{once:true,passive:true});
 });
}
setupFoHeroes(document);
document.addEventListener('shopify:section:load',event=>setupFoHeroes(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fo-service-strip"]) return;
  try {
    
function initFoStrip(){document.querySelectorAll('[data-fo-service-strip]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const links=[...root.querySelectorAll('.fo-service-strip__items a')];let index=0;const paused=matchMedia('(prefers-reduced-motion: reduce)').matches;const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return;}if(paused||document.hidden||root.matches(':hover')||root.contains(document.activeElement))return;links[index].hidden=true;index=(index+1)%links.length;links[index].hidden=false;},4500);});}
initFoStrip();document.addEventListener('shopify:section:load',initFoStrip);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
const foFooterPanels = document.querySelectorAll('.fo-footer__details');
if (window.matchMedia('(min-width:700px)').matches) {
  foFooterPanels.forEach(panel => { panel.open = true; });
}

  } catch(e) { console.error(e); }
})();
})();
